export default "__VITE_PUBLIC_ASSET__c02272f6__"